import React from 'react';
import { View } from 'react-native';
import BodySmText from 'shared/components/vxl/typography/primary/body/BodySmText';

export default function Page() {
  return (
    <View>
      <BodySmText numberOfLines={0}>
        signup/address-collection/address-verification-residential
      </BodySmText>
    </View>
  );
}
